import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import MainDashboard from "./MainDashboard";
import Login from "./Login";
import PrivateRoute from "./PrivateRoute";
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VendusDocuments from "./VendusDocuments";
import DashboardLayout from "./DashboardLayout";
import ManagerMain from "./Pages/ManagerMain";
import TechApp from "./Pages/TechApp";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/docs" element={<VendusDocuments />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <MainDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/app"
          element={
            <PrivateRoute>
              <TechApp />
            </PrivateRoute>
          }
        />
      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
        limit={4}
      />
    </Router>
  );
}

export default App;